// Platzhalter für Portal-Bereiche, die noch gebaut werden (E1-Gerüst). Keine Knöpfe.
import { Hammer } from '@phosphor-icons/react';
import { SeitenTitel } from './bausteine';

export default function BereichFolgt({ oben, titel, ohneTitel = false }: { oben: string; titel: string; ohneTitel?: boolean }) {
  return (
    <div className="p-rein" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {!ohneTitel && <SeitenTitel oben={oben} titel={titel} />}
      <div className="p-glas" style={{ borderRadius: 28, padding: '48px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, textAlign: 'center' }}>
        <Hammer size={32} style={{ color: 'var(--p-w45)' }} />
        <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--p-w55)' }}>Dieser Bereich wird gerade eingerichtet.</span>
      </div>
    </div>
  );
}
